import type { OperatorRow } from '@backrs_ui/grow-ui/src/redux/institutionAdmin';

export type OperatorHealth = Readonly<{
  /** Null where the capacity lines could not be read. */
  seats: Readonly<{ coaches: number; students: number }> | null;
  isOverCap: boolean;
  isLapsingSoon: boolean;
  isLapsed: boolean;
}>;

const usageOf = (coverage: NonNullable<OperatorRow['coverage']>, kind: string): number =>
  coverage.reduce((total, line) => (line.offeringKind === kind ? total + line.usage : total), 0);

export const operatorHealth = (operator: OperatorRow): OperatorHealth => ({
  seats:
    operator.coverage === null
      ? null
      : {
          coaches: usageOf(operator.coverage, 'coach'),
          students: usageOf(operator.coverage, 'student'),
        },
  isOverCap: operator.overCap > 0 || (operator.coverage ?? []).some((line) => line.isOver),
  isLapsingSoon: operator.lapsingSoon > 0,
  isLapsed: operator.lapse > 0,
});

export const hasIssue = ({ isOverCap, isLapsingSoon, isLapsed }: OperatorHealth): boolean =>
  isOverCap || isLapsingSoon || isLapsed;
